import { Box } from '@mui/material';
import { ApplySection } from './ApplySection/ApplySection';
import { InfoSection } from './InfoSection/InfoSection';
import { SolutionSection } from './SolutionSection/SolutionSection';
import { GetStartedSection } from './GetStartedSection/GetStartedSection';

export default function LandApp() {
  return (
    <Box>
      <ApplySection />
      <InfoSection />
      <SolutionSection />
      <GetStartedSection />
    </Box>
  );
}
